import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body,button {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

    html,
    body,
    #root {
         height: 100%;
    }
    /* WXP-143 */
    body{
      overscroll-behavior-y: contain;
    }

    html,
    body {
      /* position: fixed; */
      overflow: hidden;
    }

    #root {
      overflow-y: scroll;  
      -webkit-overflow-scrolling: touch;   /* enables “momentum” (smooth) scrolling */ 
    }



    
`;

export default GlobalStyle;
